/** Superficie pública de shared/numeric. */
export { DECIMAL_HINT_PRICE, DECIMAL_HINT_QTY, DECIMAL_HINT_PERCENT, normalizeDecimalInputRaw, formatEditableMoneyAmount, parseDecimalInput, validateDecimalField, validatePositivePriceField, parsePercentInput, inputHasDecimalSeparator, sanitizeNumericInputText, bindNumericOnChange, numericTextInputDefaults } from './localeNumeric';
export type { ParseDecimalInputOptions, ValidateDecimalFieldOptions, NumericInputKind } from './localeNumeric';

import { parsePercentInput } from './localeNumeric';
/** Coeficiente multiplicador (1 + p/100) a partir de un porcentaje en string (coma o punto decimal). */
export const bulkCoefficientFromPercent = (pct: string): number => {
  const n = parsePercentInput(pct);
  if (n === null) return 1.05;
  return 1 + n / 100;
};

// Auto-added missing exports
export { computeSalePaidPendingAmounts } from './salePaymentAmounts';
